import { useEffect, useRef } from 'react';
import { hasVisibleBrandedSurface } from './renderer-readiness';

export default function RendererReadyShell({ top = null, children }) {
  const shellRef = useRef(null);

  useEffect(() => {
    const schedule = window.requestAnimationFrame || ((callback) => window.setTimeout(callback, 0));
    const cancel = window.cancelAnimationFrame || window.clearTimeout;
    let frame;
    let stopped = false;
    const shell = shellRef.current;

    const checkReadiness = () => {
      frame = undefined;
      if (stopped || !shell || !hasVisibleBrandedSurface(shell)) return;
      shell.setAttribute('data-emberpos-renderer-ready', 'true');
      observer.disconnect();
      resizeObserver?.disconnect();
    };

    const scheduleCheck = () => {
      if (!stopped && frame === undefined) frame = schedule(checkReadiness);
    };

    const observer = new MutationObserver(scheduleCheck);
    observer.observe(shell, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    const resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(scheduleCheck)
      : null;
    resizeObserver?.observe(shell);

    scheduleCheck();

    return () => {
      stopped = true;
      if (frame !== undefined) cancel(frame);
      observer.disconnect();
      resizeObserver?.disconnect();
    };
  }, []);

  return (
    <div
      ref={shellRef}
      // The one owner of the iOS status-bar inset (viewport-fit=cover makes
      // env() non-zero; 0 on desktop/Electron/web). Wraps every gate screen,
      // so the topmost child (trial banner or header) needs no padding of its own.
      // app-shell (ticket 9095): exactly the viewport tall, never scrolls as a
      // document; `top` keeps its height, the body region takes the rest and
      // scrolls inside itself. A scrollable document kept iOS's keyboard scroll
      // offset across views (banner drawn under the status bar) and pushed
      // 100vh screens' footers below the window.
      className="safe-area-top app-shell"
      data-emberpos-brand="EmberPOS"
      aria-label="EmberPOS application"
    >
      {top}
      <div className="app-shell-body">{children}</div>
    </div>
  );
}
